import React from "react";
import classNames from "classnames";
import "assets/scss/helpers/customInput.scss";
import { default as NumberFormat } from "react-number-format";

export default function CustomPhoneInput(props) {
  const {
    startIcon,
    disabled = false,
    endIcon,
    style,
    formGroup = true,
    inputProps = false,
    onValueChange,
    id,
    inputClass = false,
    key = 0,
    keyValue,
    format = "(###) ### ####",
  } = props;
  const formField = classNames({
    "form-feild": true,
    outlineFormField: inputProps.error && true,
    [inputClass]: inputClass && true,
    errorField: inputProps.error && true,
  });
  return (
    <React.Fragment key={keyValue ? keyValue : key}>
      <div
        className={classNames({
          formGroup: formGroup ? true : false,
          style: style ? true : false,
        })}
        style={style}
        key={keyValue ? keyValue : key}
      >
        {startIcon && startIcon}
        <NumberFormat
          format={format}
          onValueChange={onValueChange}
          className={formField}
          id={id}
          {...inputProps}
          disabled={disabled}
        />
        {endIcon && endIcon}
      </div>
      {inputProps.error && (
        <div className="errorMessage" key={keyValue ? keyValue : key}>
          {inputProps.error}
        </div>
      )}
    </React.Fragment>
  );
}
